import { Outlet } from 'react-router-dom';

import Styles from './index.module.scss';
import { Sidebar } from './sidebar';

import { SidebarProvider } from '@/app/context/SidebarContext';
import { ConfirmModalProvider } from '@/components/Modals/AsyncModal/Provider';

export const NavigationLayout = () => {
	return (
		<SidebarProvider>
			<ConfirmModalProvider>
				<div className={Styles.container}>
					<Sidebar />
					<div className={Styles.pageContainer}>
						<Outlet />
					</div>
				</div>
			</ConfirmModalProvider>
		</SidebarProvider>
	);
};
